import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=f4c7dc36&scoped=true&"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=f4c7dc36&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c7dc36",
  null
  
)

export default component.exports